import {
  faChevronDown,
  faSpinnerThird,
} from '@fortawesome/pro-solid-svg-icons';
import { MenuButton } from '@reach/menu-button';
import '@reach/menu-button/styles.css';
import PropTypes from 'prop-types';

import { Icon } from '../Icons';

import './styles/buttonStyles.css';
import './styles/buttonSmallStyles.css';

// This component is deprecated in favor of the <MenuButton/> from the __pds folder

export const sizeStyles = {
  small: 'button-small',
  default: '',
};

const typeStyles = {
  primary: 'button-primary',
  secondary: 'button-secondary',
  subtle: 'button-subtle',
  tertiary: 'button-tertiary',
};

const DropdownButton = ({
  children,
  disabled,
  isLoading,
  size,
  type,
  ...rest
}) => {
  const icon = isLoading ? faSpinnerThird : faChevronDown;

  return (
    <MenuButton
      className={`${typeStyles[type] || ''} ${sizeStyles[size] || ''}`}
      disabled={disabled || isLoading}
      {...rest}
    >
      {children} <Icon aria-hidden icon={icon} spin={isLoading} />
    </MenuButton>
  );
};

DropdownButton.defaultProps = {
  disabled: false,
  isLoading: false,
  size: 'default',
};

DropdownButton.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * Whether the button is in a disabled state or not
   */
  disabled: PropTypes.bool,
  /**
   * Whether the button is in a loading state or not
   */
  isLoading: PropTypes.bool,
  /**
   * Size of the button
   */
  size: PropTypes.oneOf(['default', 'small']),
  /**
   * Variant of the button
   */
  type: PropTypes.oneOf(['primary', 'secondary', 'subtle', 'tertiary'])
    .isRequired,
};

export default DropdownButton;
